import { render, staticRenderFns } from "./CatalogListItem.vue?vue&type=template&id=2d7a996b&scoped=true&"
import script from "./CatalogListItem.vue?vue&type=script&lang=js&"
export * from "./CatalogListItem.vue?vue&type=script&lang=js&"
import style0 from "./CatalogListItem.vue?vue&type=style&index=0&id=2d7a996b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7a996b",
  null
  
)

export default component.exports